import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const DriverRecruitmentSelectionPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  hrContact,
  transportManagerContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Driver_Recruitment_Selection_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Driver Recruitment & Selection Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        This policy outlines the principles and procedures for the recruitment and selection of drivers to ensure a fair, consistent, and compliant process aligned with legal and safety requirements.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all recruitment and selection activities for driver roles within {clientName || "the Company"}.
      </p>

      <h4 className="section-title">3. Equal Opportunity</h4>
      <p className="section-content">
        {clientName || "The Company"} is committed to equality and diversity in recruitment. All candidates will be assessed fairly without discrimination on grounds of age, gender, ethnicity, disability, religion, sexual orientation, or any other protected characteristic.
      </p>

      <h4 className="section-title">4. Recruitment Process</h4>
      <ul>
        <li><strong>Job Description:</strong> Clearly define the duties, responsibilities, and requirements of the driver role.</li>
        <li><strong>Advertising:</strong> Vacancies will be advertised through appropriate channels to attract suitable candidates.</li>
        <li><strong>Application:</strong> Candidates must complete a standard application form to ensure consistency.</li>
      </ul>

      <h4 className="section-title">5. Selection Process</h4>
      <ul>
        <li><strong>Shortlisting:</strong> Applications will be screened against criteria relevant to the job.</li>
        <li><strong>Interviews:</strong> Candidates will be interviewed using a structured format focusing on skills, experience, and attitude.</li>
        <li><strong>Testing:</strong> Where appropriate, candidates will undergo assessments including driving tests, medical checks, and licence verification.</li>
        <li><strong>Reference Checks:</strong> At least two references will be taken, including previous employers where applicable.</li>
        <li><strong>Background Checks:</strong> DBS or equivalent checks will be carried out as required.</li>
      </ul>

      <h4 className="section-title">6. Driver Qualifications and Compliance</h4>
      <p className="section-content">
        All recruited drivers must hold valid licences appropriate to the vehicle type and comply with all legal requirements including CPC qualifications and medical fitness standards.
      </p>

      <h4 className="section-title">7. Induction and Training</h4>
      <p className="section-content">
        New drivers will receive a full induction covering company policies, health & safety, vehicle familiarisation, and job expectations. Ongoing training will be provided as necessary.
      </p>

      <h4 className="section-title">8. Record Keeping</h4>
      <p className="section-content">
        Comprehensive records of recruitment, selection, and induction will be maintained in compliance with data protection legislation.
      </p>

      <h4 className="section-title">9. Policy Review</h4>
      <p className="section-content">
        This policy will be reviewed annually or when changes in legislation or company procedures require.
      </p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I acknowledge that I have read and understood the Driver Recruitment & Selection Policy and agree to abide by its terms.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now effective.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default DriverRecruitmentSelectionPolicy;
